<script>
import { mapState } from 'vuex'
import LadCoverMedia from './media'

export default {
  name: 'LadCoverImage',
  extends: LadCoverMedia,
  props: {
    cover: { type: String, default: null },
  },
  computed: {
    ...mapState('experience', {
      image(state) {
        return { src: this.cover ? this.cover : state.cover.url }
      },
    }),
  },
}
</script>
